import { useCallback, useRef, useState } from "react";

type AsyncAction<T extends unknown[] = []> = (...args: T) => Promise<void>;

function useAsyncAction<T extends unknown[]>(
    asyncAction: AsyncAction<T>,
): [AsyncAction<T>, boolean] {
    const [loading, setLoading] = useState(false);
    const loadingRef = useRef(false);

    const runAction: AsyncAction<T> = useCallback(
        async (...args: T) => {
            if (loadingRef.current) return;

            loadingRef.current = true;
            setLoading(true);

            try {
                await asyncAction(...args);
            } catch (error) {
                console.error(error);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        },
        [asyncAction],
    );

    return [runAction, loading];
}

export default useAsyncAction;
